import listReducer from './list';

export default {
    listReducer,
};
